module.exports = __webpack_public_path__ + "static/img/13.f9dd8d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/13.jpg
// module id = 284
// module chunks = 0